import * as Sentry from "@sentry/react";

import { AppContent } from "./AppContent";

export const App = Sentry.withProfiler(AppContent);
